module.exports = __webpack_public_path__ + "img/APL.92fc3206.png";